export const isValidMailAddress = (mail: string): boolean => {
  return /^.+@.+\..+$/.test(mail)
}
